import { memo, useCallback } from 'react';
import cn from 'classnames';
import { AuthUtils } from 'src/utils';
import { Element, Icon } from 'src/components';
import Menu from 'src/components/menu';
import RouterLink from 'src/components/links';
import useAuth from 'src/hooks/useAuth';

const settingMenu = [
    {
        icon: 'award1',
        name: 'Tin cho bạn',
        url: '/tin-cho-ban.epi',
    },
    {
        name: 'Mục của bạn',
        url: '/muc-cua-ban.epi',
        icon: 'folder-open',
    },
    {
        name: 'Theo dõi',
        url: '/theo-doi.epi',
        icon: 'wifi',
    },
    {
        icon: 'history',
        name: 'Đọc gần đây',
        url: '/doc-gan-day.epi',
    },
    {
        icon: 'bookmark',
        name: 'Tin đã lưu',
        url: '/tin-da-luu.epi',
    },
];
function DropdownSetting() {
    const { logout } = useAuth();
    const handleLogout = useCallback(() => {
        logout();
    }, []);

    const renderSetting = useCallback(() => {
        return settingMenu.map((item, index: number) => (
            <Menu.List.Item
                key={`parent.${index}`}
                className={cn('border-b border-solid border-b-[#eee]')}
            >
                <RouterLink
                    className={cn(
                        'flex items-center',
                        'h-[40px] w-full',
                        'px-[20px]',
                        'text-[#333]'
                    )}
                    to={item.url}
                >
                    <Icon
                        className={cn('w-[1em] text-[1.8rem] mr-[10px]', {
                            ['translate-x-[-5px] rotate-45']:
                                item.icon === 'wifi',
                        })}
                        icon={item.icon}
                    />
                    <Element renderAs="span">{item.name}</Element>
                </RouterLink>
            </Menu.List.Item>
        ));
    }, [settingMenu]);

    return (
        <Menu.List>
            {renderSetting()}
            <Menu.List.Item onClick={handleLogout}>
                <Element
                    className={cn(
                        'flex items-center',
                        'h-[40px] w-full',
                        'px-[20px]',
                        'text-[#333]'
                    )}
                    renderAs="button"
                >
                    <Icon
                        className={cn('w-[1em] text-[1.8rem] mr-[10px]')}
                        icon="sign-out-alt"
                    />
                    <Element renderAs="span">Đăng xuất</Element>
                </Element>
            </Menu.List.Item>
        </Menu.List>
    );
}

export default memo(DropdownSetting);
